import styled from 'styled-components'

const Container = styled.div`
  img{
    display: none;
  }
  p{
    margin-top: 1.5rem;
  }
`

export default Container
